module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-18.8b8e4c0a.svg";